var _title, _path;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgColorado = function SvgColorado(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239.28,
    height: 186,
    viewBox: "0 0 239.28 186",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "colorado")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241.55,49.54l-68.26-6.63L23.31,26.6,19.14,68.5,5.87,164.06l-3.6,26,64.46,7.39,71.1,8.34,65.8,5.69,27.11,1.14Z",
    transform: "translate(-2.27 -26.6)"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgColorado, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/colorado.e0417b65.svg";
export { ForwardRef as ReactComponent };